module.exports = __webpack_public_path__ + "static/media/02-Holland-Park.14d1e1bd.mp4";